import { useForm } from '@inertiajs/react'
import BlogPostForm from "./BlogPostForm"

interface BlogPost {
  id: number
  title: string
  excerpt: string
  content: string
  slug: string
  published: boolean
  featured: boolean
  tags_string?: string
}

interface EditBlogPostProps {
  blogPost: BlogPost
  onSuccess?: () => void
  onCancel?: () => void
}

const EditBlogPost = ({ blogPost, onSuccess, onCancel }: EditBlogPostProps) => {
  const { data, setData, put, processing, errors, reset } = useForm({
    title: blogPost.title,
    excerpt: blogPost.excerpt,
    content: blogPost.content,
    slug: blogPost.slug,
    tags_string: blogPost.tags_string || '',
    published: blogPost.published,
    featured: blogPost.featured
  })

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    put(`/admin/blog_posts/${blogPost.id}`, {
      onSuccess: () => {
        reset()
        onSuccess?.()
      }
    })
  }

  return (
    <BlogPostForm
      data={data}
      setData={setData}
      onSubmit={handleSubmit}
      onCancel={onCancel}
      submitLabel="Update Blog Post"
      processing={processing}
      errors={errors}
    />
  )
}

export default EditBlogPost 